export default "__VITE_ASSET__CwBcdbVy__"